import { OMY_SETTING, OmyConst } from "../OmyConst";
import Omy from "../Omy";

export default class NavigateBtns {
    constructor() {
        this._stateBtn = 0;
        this._onUpEvent = "up_state";
        this._onBlockEvent = "block_state";

        this._emit = new OmyConst.Emit();
        this._isScreenBlock = false;
        this._countBlockCall = 0;
    }

    updateState(state) {
        this._stateBtn = state;
        if (Omy.debugMode && OMY_SETTING.VERBOSE_BUTTONS_STATE)
            Omy.warn("btn state: ", this._stateBtn);
        this._emit.emit(this._onUpEvent, state);
    }

    updateLastState() {
        this._emit.emit(this._onUpEvent, this._stateBtn);
        if (Omy.debugMode && OMY_SETTING.VERBOSE_BUTTONS_STATE)
            Omy.warn("btn last state: ", this._stateBtn);
    }

    addBtn(btn, funcState = null, funcBlock = null) {
        if (funcState)
            this._emit.on(this._onUpEvent, funcState, btn);
        if (funcBlock)
            this._emit.on(this._onBlockEvent, funcBlock, btn);
    }

    removeBtn(btn, funcState, funcBlock) {
        if (funcState)
            this._emit.removeListener(this._onUpEvent, funcState, btn);
        if (funcBlock)
            this._emit.removeListener(this._onBlockEvent, funcBlock, btn);
    }

    addUpdateState(func, context) {
        this._emit.on(this._onUpEvent, func, context);
    }

    addBlockState(func, context) {
        this._emit.on(this._onBlockEvent, func, context);
    }

    removeUpdateState(func, context) {
        this._emit.removeListener(this._onUpEvent, func, context);
    }

    removeBlockState(func, context) {
        this._emit.removeListener(this._onBlockEvent, func, context);
    }

    blockingScreen() {
        this._countBlockCall++;
        this._emit.emit(this._onBlockEvent, true);

        OMY_SETTING.VERBOSE_BUTTONS_STATE && Omy.warn("blockingScreen");
    }

    globalBlockingScreen() {
        this._isScreenBlock = true;
        this._emit.emit(this._onBlockEvent, true);
        this._emit.removeAllListeners(this._onUpEvent);
        this._emit.removeAllListeners(this._onBlockEvent);
    }

    unBlockingScreen() {
        this._countBlockCall--;
        if (this._countBlockCall < 0) this._countBlockCall = 0;
        this._emit.emit(this._onBlockEvent, false);

        OMY_SETTING.VERBOSE_BUTTONS_STATE && Omy.warn("unBlockingScreen");
    }

    get state() {
        return this._stateBtn;
    }

    get isScreenBlock() {
        return this._isScreenBlock || this._countBlockCall > 0;
    }
}
